import React from 'react';
import formatDate from 'date-fns/format';
import parse from 'date-fns/parse';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';
import TimePicker, { FORMAT_24H } from '@/components/TimePicker';

import { FrequencyComponentProps } from '../../types';
import FrequencyInput from '../InputComponents/Frequency';

const Daily = ({
  value,
  onChange,
  hideTimeSelection,
  disabled,
  allowedFrequencies,
  size,
}: FrequencyComponentProps) => {
  const { t } = useTranslation();

  const displayValue = parse(value.time, FORMAT_24H, new Date());
  return (
    <Stack alignItems="center" justifyContent="between">
      <FrequencyInput
        allowedFrequencies={allowedFrequencies}
        disabled={disabled}
        size={size}
        value={value}
        onChange={onChange}
      />
      {hideTimeSelection ? null : (
        <>
          <Typography
            className="mx-12"
            variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
            {t('At')}
          </Typography>
          <TimePicker
            className="w-1/2"
            disabled={disabled}
            size={size}
            value={displayValue}
            onChange={(date) => {
              onChange({ ...value, time: formatDate(date, FORMAT_24H) });
            }}
          />
        </>
      )}
    </Stack>
  );
};

export default Daily;
